<template>
  <v-data-table
    v-model="selecionados"
    v-bind="$attrs"
    :headers="headersNormalizado"
    :search="busca"
    :footer-props="{
      showFirstLastPage: true,
      'items-per-page-options': [10, 20, 50, 100, 200, 300, 1000, 3000, 5000, 10000]
    }"
    class="mb-10"
    v-on="$listeners"
  >
    <template #[`item.actions`]="{ item }">
      <div class="d-flex flex-nowrap justify-center">
        <v-tooltip v-if="editar" top>
          <template #activator="{ on }">
            <v-icon
              :disabled="!podeEditar"
              class="mr-1"
              v-on="on"
              @click="() => $emit('update', $attrs.items.indexOf(item))"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Editar</span>
        </v-tooltip>

        <v-tooltip v-if="configurar" top>
          <template #activator="{ on }">
            <v-icon
              :disabled="!podeEditar"
              class="mr-1"
              v-on="on"
              @click="() => $emit('configure', $attrs.items.indexOf(item))"
            >
              mdi-cog
            </v-icon>
          </template>
          <span>Configurar</span>
        </v-tooltip>

        <v-tooltip v-if="remover" top>
          <template #activator="{ on }">
            <v-icon
              :disabled="!podeRemover"
              class="mr-1"
              v-on="on"
              @click="() => $emit('delete', $attrs.items.indexOf(item))"
            >
              mdi-delete
            </v-icon>
          </template>
          <span>Excluir</span>
        </v-tooltip>

        <v-tooltip v-if="info" top>
          <template #activator="{ on }">
            <v-icon v-on="on" @click="() => $emit('info', $attrs.items.indexOf(item))">
              mdi-information
            </v-icon>
          </template>
          <span>Informações</span>
        </v-tooltip>
      </div>
    </template>

    <template #top>
      <v-toolbar v-if="titulo !== ''" flat color="white">
        <v-toolbar-title>{{ titulo }}</v-toolbar-title>
      </v-toolbar>
      <v-toolbar flat class="pt-3 mb-3">
        <v-row>
          <v-col>
            <v-text-field v-if="permiteBuscar()" v-model="busca" label="Buscar" />
          </v-col>
          <v-col class="text-right">
            <v-btn
              v-if="adicionar"
              :disabled="!podeAdicionar"
              color="primary"
              class="mb-2"
              @click="() => $emit('create')"
            >
              Adicionar
            </v-btn>
            <v-btn
              v-if="editarEmLote"
              :disabled="permiteEditarEmLote()"
              color="primary"
              class="mb-2 ml-2"
              @click="
                () =>
                  $emit(
                    'multi-update',
                    selecionados.map((item) => item.id)
                  )
              "
            >
              Edição em Lote
            </v-btn>
          </v-col>
        </v-row>
      </v-toolbar>
    </template>

    <template v-for="header in this.$attrs.headers" #[`item.${header.value}`]="{ item }">
      <slot :name="[`item.${header.value}`]" :item="item">
        {{ getVal(item, header.value) }}
      </slot>
    </template>

    <template #no-data>
      <slot name="no-data" />
    </template>
  </v-data-table>
</template>

<script>
import store from '@/store'

export default {
  props: {
    titulo: {
      type: String,
      default: ''
    },
    rotinaId: {
      type: String,
      default: ''
    },
    adicionar: {
      type: Boolean,
      default: true
    },
    editar: {
      type: Boolean,
      default: true
    },
    editarEmLote: {
      type: Boolean,
      default: false
    },
    configurar: {
      type: Boolean,
      default: true
    },
    remover: {
      type: Boolean,
      default: true
    },
    info: {
      type: Boolean,
      default: false
    },
    permissaoGeral: {
      type: Boolean,
      default: false
    },
    buscar: {
      type: Boolean,
      default: true
    },
    buscaParam: {
      type: String,
      default: ''
    },
    itensSelecionados: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    name: 'DataTableDeCrud',
    busca: '',
    selecionados: []
  }),

  computed: {
    headersNormalizado() {
      return [
        ...this.$attrs.headers,
        { text: '', value: 'actions', sortable: false, align: 'center', width: '1%' }
      ]
    },
    podeAdicionar() {
      return this.podeRealizarOperacao('ADICIONAR')
    },
    podeEditar() {
      return this.podeRealizarOperacao('EDITAR')
    },

    podeRemover() {
      return this.podeRealizarOperacao('REMOVER')
    }
  },

  watch: {
    itensSelecionados() {
      return this.itensSelecionados ? (this.selecionados = this.itensSelecionados) : ''
    }
  },

  mounted() {
    this.busca = this.buscaParam ? this.buscaParam : ''
  },

  methods: {
    getVal(item, path) {
      return path.split('.').reduce((res, prop) => res[prop] || '', item)
    },

    podeRealizarOperacao(operacao) {
      if (this.permissaoGeral) return true
      return store.getters.verificaSeTemPermissao(this.rotinaId, operacao)
    },

    permiteEditarEmLote() {
      if (this.selecionados.length > 0) return false
      return true
    },

    permiteBuscar() {
      return this.buscar
    }
  }
}
</script>
